import domReady from '@roots/sage/client/dom-ready';
import GlobalHamburger from './components/global-hamburger';
import CardList from './components/card-list';
import NewsList from './components/news-list';
import Faq from './components/faq';
import FinancialReport from './components/financial-report';
import Shareholder from './components/shareholder';
import AccessTab from './components/access-tab';
import targetBlank from './components/target-blank';
import ChartIRSituation from './components/chart_ir-situation';
import ChartENIRHighlights from './components/chart_en-ir-highlights';

/**
 * Application entrypoint
 */
domReady(async () => {
  GlobalHamburger.exec();
  CardList.exec();
  NewsList.exec();
  Faq.exec();
  FinancialReport.exec();
  Shareholder.exec();
  AccessTab.exec();
  targetBlank.exec();
  ChartIRSituation.exec();
  ChartENIRHighlights.exec();
});

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) import.meta.webpackHot.accept(console.error);
